import { JSX } from 'react';
import { InView } from 'react-intersection-observer';

import { CircleImageModifier } from '@src/components/circle-image-modifier';

export default function Info({
  descendants,
  analytics,
  onSectionView,
}: {
  descendants: {
    title: string | JSX.Element;
    text: string | JSX.Element;
  }[];
  analytics: {
    label: string;
    value: string;
  };
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
}): JSX.Element {
  return (
    <section id="info" className="pi-careplus__info">
      <div className="pi-careplus__info--content">
        <InView
          as="h2"
          triggerOnce={true}
          onChange={(inView: any) => {
            if (!inView) return;
            onSectionView(analytics.label, analytics.value);
          }}
          className="pi-careplus__info--title"
        >
          Insurance developed by pet lovers for pet lovers.
        </InView>
        <p className="pi-careplus__info--text">
          You deserve wellness and insurance plans that you can count on to be
          pet-first. CarePlus is here to deliver it.
        </p>
      </div>
      <div className="pi-careplus__info--image">
        <CircleImageModifier
          imgSrc="/pet-insurance/img/owner-pet-smooches.png"
          accPos="left"
          lazy={true}
        />
      </div>
      <ul className="pi-careplus__info--cards">
        {descendants.map(
          (
            {
              title,
              text,
            }: {
              title: string | JSX.Element;
              text: string | JSX.Element;
            },
            i: number,
          ): JSX.Element => {
            const name = `pi-careplus__info--card-${i}`;
            return (
              <li key={name} className={`pi-careplus__info--card ${name}`}>
                <h3 className="pi-careplus__info--subtitle">{title}</h3>
                <p className="pi-careplus__info--subtext">{text}</p>
              </li>
            );
          },
        )}
      </ul>
    </section>
  );
}
